import { UseIsMobile } from 'common/hooks/UseIsMobile';
import AccountActivationDesktop from './desktop';
import AccountActivationMobile from './mobile';
import { Navigate } from 'react-router-dom';

const AccountActivation = () => {
  const mobile = UseIsMobile();

  if (!Boolean(window.api.ACCOUNT_ACTIVATION))
    return <Navigate to={'/login'} />;

  return (
    <div>
      {mobile ? (
        <div className="md:hidden">
          <AccountActivationMobile />
        </div>
      ) : (
        <div className="hidden md:block">
          <AccountActivationDesktop />
        </div>
      )}
    </div>
  );
};

export default AccountActivation;
